// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__M4_7a","content":"GlobalSearch_content__wwfZf"};